/**
 * Copyright 2020-present, TIENDUC.
 * All rights reserved.
 * @author ductt24@ghtk.vn on 18/08/2020.
 * @module TRUCK REDUCER
 */

import { createSlice } from "@reduxjs/toolkit";
import { MODULE_NAME } from "./constants";

const truckSlice = createSlice({
  name: `${MODULE_NAME}/truck`,
  initialState: {
    plates: [],
    listVehicle: [],
    listTrucker: [],
    count: undefined,
    totalTruck: undefined,
    status: {},
    report: {
      data: [],
      count: 0,
      linkDownload: undefined
    },
    firmware: {
      count: 0,
      data: []
    },
    device: {
      data: [],
      count: 0
    },
    deviceV2: {
      data: [],
      count: 0
    }
  },
  reducers: {
    getListVehicle(state, action) {
      state.listVehicle = action.payload.data;
      state.totalTruck = action.payload.count;
      return state;
    },
    browseTruckerInfo(state, action) {
      state.listTrucker = action.payload.data;
      state.count = action.payload.count;
      return state;
    },
    getVehicleStatus(state, action) {
      state.status = action.payload;
      return state;
    },
    getReport(state, action) {
      state.report.data = action.payload.data;
      state.report.linkDownload = action.payload.linkDownload;
      state.report.count = action.payload.count;
      return state;
    },
    getFirmwareInfo(state, action) {
      state.firmware.count = action.payload.count;
      state.firmware.data = action.payload.data;
      return state;
    },
    getDeviceInfo(state, action) {
      state.device.count = action.payload.count;
      state.device.data = action.payload.data;
      return state;
    }
  }
});
export const truckActions = truckSlice.actions;
export const truckReducer = truckSlice.reducer;
